module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {}, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "26vh"
    },
    attrs: {
      "src": "static/assets/images/shouye_bg.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 detail_title"
  }, [_c('h3', [_vm._v(_vm._s(_vm.detailDatda.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 detail_brief"
  }, [(_vm.detailDatda.content != null) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.detailDatda.content)
    }
  }) : _c('div', [_c('el-empty', {
    attrs: {
      "description": "暂无数据"
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4964f260"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/detail.vue
// module id = 292
// module chunks = 1